import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState, useEffect } from "react";
import { createMediaBookmark, deleteMediaBookmark, MEDIA_KEY } from "../api/public-voissa/medias";
import { USER_BOOKMARKS_MEDIAS_KEY } from "../api/public-voissa/users";

const useMediaBookMark = (
    isInitialBookmarked = false,
    mediaId
)=>{
    const queryClient = useQueryClient();
    const [isBookmarked, setToggleBookmark] = useState(!!isInitialBookmarked);
    const {
        mutate,
    } = useMutation(() => {
        isInitialBookmarked ? deleteMediaBookmark(mediaId) : createMediaBookmark(mediaId);
    },{
        onSuccess: async () =>{
            await queryClient.invalidateQueries([MEDIA_KEY, mediaId]);
            await queryClient.invalidateQueries([USER_BOOKMARKS_MEDIAS_KEY]);
        },
        onError: () =>{
            setToggleBookmark(!isBookmarked);
        }
    });

    function handleBookmark() {
        mutate();
        setToggleBookmark(!isBookmarked);
    }

    useEffect(() => {
        setToggleBookmark(isBookmarked)
    }, [isBookmarked]);

    useEffect(() => {
        setToggleBookmark(isInitialBookmarked)
    }, [isInitialBookmarked]);

    return {isBookmarked, handleBookmark}
}

export default useMediaBookMark;